import React from 'react';
import { useMsal } from '@azure/msal-react';
import './Logout.css';

const Logout = () => {
    const { instance } = useMsal();

    const handleLogin = async () => {
        try {
            await instance.loginRedirect({
                redirectStartPage: window.location.origin + '/'
            });
        } catch (error) {
            // Silent error handling
        }
    };

    return (
        <div className="logout-container">
            <div className="logout-card">
                <div className="logout-icon-container">
                    <svg className="logout-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </div>
                <h1 className="logout-title">Successfully Logged Out</h1>
                <p className="logout-message">
                    You have been logged out of your account
                </p>
                <button onClick={handleLogin} className="logout-login-button">
                    Log In Again
                </button>
            </div>
        </div>
    );
};

export default Logout;
